import React, { useEffect } from 'react';
import { pageTitle } from '../../helper';
import Cta from '../Cta';
import PageHeading from '../PageHeading';
import Div from '../Div';
import Spacing from '../Spacing';
import SocialWidget from '../Widget/SocialWidget';
import { useLocation } from 'react-router-dom';

export default function TeamDetails() {
  pageTitle('Team Member');
  const { state } = useLocation();

  // Destructure the props from state
  const {
    memberImage,
    memberName,
    bio,
    memberDesignation,
    memberSocial,
  } = state || {};

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // If a user navigates directly to `/team-details` without state, handle that gracefully:
  if (!state) {
    return <div className="container">No team member selected.</div>;
  }

  return (
    <>
      <PageHeading 
        title="Team Details"
        bgSrc="/images/team_hero_bg.jpg"
        pageLinkText="Team Details"
      />
      <Spacing lg="150" md="80"/>
      <Div className="container">
        <Div className="row align-items-center">
          <Div className="col-xl-5 col-lg-6">
            <Div className="cs-radius_15 cs-shine_hover_1">
              <img src={memberImage} alt={memberName} className="w-100" />
            </Div>
          </Div>
          <Div className="col-lg-6 offset-xl-1">
            <Spacing lg="0" md="45"/>
            <Div className="cs-section_heading cs-style1">
              <h2 className="cs-section_title">{memberName}</h2>
              <Div className="cs-height_10 cs-height_lg_10" />
              <h3 className="cs-section_subtitle">{memberDesignation}</h3>
              <Div className="cs-height_5 cs-height_lg_5" />
              <Div className="cs-separator cs-accent_bg" />
              <Div className="cs-height_45 cs-height_lg_25" />
              <p className="cs-m0">
                {bio}
              </p>
              <Div className="cs-height_45 cs-height_lg_30" />
              <SocialWidget socialLinks={memberSocial} />
            </Div>
          </Div>
        </Div>
      </Div>
      <Spacing lg="150" md="80"/>
      <Div className="container">
        <Cta
          title="Let’s collaborate make <br />something <i>exceptional</i> together"
          btnText="Apply For Meeting"
          btnLink="/contact"
          bgSrc="/images/cta_bg.jpeg"
        />
      </Div>
    </>
  );
}
